import { useCallback } from "react";
import { message } from "antd";
import { MakeApiCall } from "../apis";
import { useThemeMode } from "../contexts/ThemeContext";

export function useThemePreference(userData, setData) {
  const { themeMode, setThemeMode } = useThemeMode();

  const toggleTheme = useCallback(async () => {
    const previousTheme = themeMode;
    const nextTheme = themeMode === "dark" ? "light" : "dark";

    setThemeMode(nextTheme);

    if (typeof setData === "function" && userData?.user?.user_data) {
      setData({
        ...userData,
        user: {
          ...userData.user,
          user_data: {
            ...userData.user.user_data,
            theme: nextTheme,
          },
        },
      });
    }

    const token = userData?.token;
    if (!token) {
      return;
    }

    const response = await MakeApiCall(
      "user/theme",
      "post",
      { theme: nextTheme },
      true,
      {},
      token
    );

    if (response?.status === true) {
      return;
    }

    setThemeMode(previousTheme);

    if (typeof setData === "function" && userData?.user?.user_data) {
      setData({
        ...userData,
        user: {
          ...userData.user,
          user_data: {
            ...userData.user.user_data,
            theme: previousTheme,
          },
        },
      });
    }

    message.destroy();
    message.error(response?.message || "Failed to save theme preference.");
  }, [themeMode, setThemeMode, userData, setData]);

  return { themeMode, toggleTheme };
}
